import { QuestionGroupLibraryPage } from '@/components/QuestionGroups/QuestionGroupLibraryPage'

export default function QuestionGroupsRoute() {
  return <QuestionGroupLibraryPage />
}
